import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { AddStaticContentArea, All, LoadStaticContentAreas, RemoveStaticContentArea } from '../../actions/area'
import { StaticContentAreaApi } from '../../apis'
import { Area } from '../../models'
import { AppState } from '../../reducers'
import { AreaService } from './base'

@Injectable()
export class StaticContentAreaService extends AreaService{
  protected LoadAreas(resourceId: number, areas: Area[]): All {
    return new LoadStaticContentAreas(resourceId, areas)
  }
  protected AddArea(area: Area): All {
    return new AddStaticContentArea(area)
  }
  protected RemoveArea(areaId: number): All {
    return new RemoveStaticContentArea(areaId)
  }
  constructor(protected api: StaticContentAreaApi, protected store: Store<AppState>) {
    super(api, store)
  }
}



// WEBPACK FOOTER //
// ./src/services/area/static-content.ts